import React from 'react';
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import { connect } from 'react-redux'
import { customerNameById, formatKennitala, formatKennitalaAsDate } from '../../utils'
import { createPayerVirtualcard, createPayerDepositSlip, removeTempCC } from '../../api/payers/actions'
import { removeVirtualCard } from '../../api/virtual-card/actions'
import { mapProductToPayer } from '../../api/payers/actions'
import CardForm from '../card-form'
import { setKey } from '../../api/insurance-takers/actions'

import { fetchNationalRegistry } from '../../api/national-registry/actions'
import tilbodStepHealthQuestions from '../tilbod-step-health-questions';

const kennitala = require('kennitala')


class CitizenshipModal extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            citizenship1: '',
            citizenship2: '',
            citizenship3: '',
        }

        this.submitCitizenship = this.submitCitizenship.bind(this)
        this.onChangeInput = this.onChangeInput.bind(this)
    }

    componentDidMount(){
        initialInputState();
        let that = this;
        $('#CitizenshipModal').on('hidden.bs.modal', function () {
            that.clearModal();
        });
    }

    componentDidUpdate(){
        initialInputState();
    }

    clearModal(){
        setTimeout(() => {
            this.setState({
                citizenship1: '',
                citizenship2: '',
                citizenship3: '',
            });
        }, 500)
    }

    onChangeInput(ev, key) {
        this.setState({[key]: ev.target.value})
    }

    submitCitizenship(){
        let citizenships = []
        if (this.state.citizenship1) {
            citizenships.push(this.state.citizenship1)
        }
        if (this.state.citizenship2) {
            citizenships.push(this.state.citizenship2)
        }
        if (this.state.citizenship3) {
            citizenships.push(this.state.citizenship3)
        }
        Promise.resolve(this.props.dispatch(
            setKey({key: "citizenships", value: citizenships.join(", ")}, this.props.insuranceTakerId)
        )).then(this.clearModal())
    }


    render() {

        return (
            <div className="modal citizenship-modal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel"
                aria-hidden="true" id={this.props.id}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            Skráning ríkisborgararéttar
                            <button type="button" className="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                        </div>
                        <div className="modal-body">
                            <div>
                                <div className="form-row options col-sm-12">
                                    <div className="col-12">
                                        <div className="form-check">
                                            <label htmlFor="citizenship-1" className="form-check-label">Land 1</label>
                                            <input type="text" className="form-control" id="citizenship-1" name="citizenship-1" onChange={(e) => this.onChangeInput(e, 'citizenship1')} value={this.state.citizenship1} />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row options col-sm-12">
                                    <div className="col-12">
                                        <div className="form-check">
                                            <label htmlFor="citizenship-2" className="form-check-label">Land 2</label>
                                            <input type="text" className="form-control" id="citizenship-2" name="citizenship-2" onChange={(e) => this.onChangeInput(e, 'citizenship2')} value={this.state.citizenship2} />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row options col-sm-12">
                                    <div className="col-12">
                                        <div className="form-check">
                                            <label htmlFor="citizenship-3" className="form-check-label">Land 3</label>
                                            <input type="text" className="form-control" id="citizenship-3" name="citizenship-3" onChange={(e) => this.onChangeInput(e, 'citizenship3')} value={this.state.citizenship3} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <button className="btn btn-primary" type="button" onClick={this.submitCitizenship} data-dismiss="modal">Vista</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

CitizenshipModal.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        insuranceTakers: {},
    }
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers

    return f;
}

export default connect(mapStateToProps)(CitizenshipModal);